import type { CompanyTableColumnDef, CompanyTableColumnFilterOption } from '../types/company-table-column.types';
import { formatTableCell } from './grid-cell-format';

const EMPTY_KEY = '__COMPANY_TABLE_EMPTY__';

export function stableColumnFilterValue(cellValue: unknown): string {
  if (cellValue === null || cellValue === undefined || cellValue === '') return EMPTY_KEY;
  if (typeof cellValue === 'number' && Number.isFinite(cellValue)) return `n:${cellValue}`;
  if (typeof cellValue === 'boolean') return `b:${String(cellValue)}`;
  if (typeof cellValue === 'string') return `s:${cellValue}`;
  return `j:${JSON.stringify(cellValue)}`;
}

export function cellMatchesStableFilterKeys(cellValue: unknown, selectedKeys: readonly string[]): boolean {
  if (selectedKeys.length === 0) return true;
  return selectedKeys.includes(stableColumnFilterValue(cellValue));
}

export function buildAutoFilterOptions(
  rows: readonly Record<string, unknown>[],
  col: Pick<CompanyTableColumnDef, 'field' | 'type'>,
  numberFractionDigits: number,
): CompanyTableColumnFilterOption[] {
  const seen = new Map<string, unknown>();
  for (const row of rows) {
    const raw = row[col.field];
    const k = stableColumnFilterValue(raw);
    if (!seen.has(k)) seen.set(k, raw);
  }
  const options: CompanyTableColumnFilterOption[] = [];
  for (const [k, raw] of seen) {
    const text =
      k === EMPTY_KEY
        ? '—'
        : formatTableCell(raw, { field: col.field, type: col.type }, { numberFractionDigits });
    options.push({ text, value: k });
  }
  options.sort((a, b) => String(a.text).localeCompare(String(b.text), 'pt-BR', { numeric: true }));
  return options;
}

export function defaultColumnFilterMatch(selected: unknown, cellValue: unknown): boolean {
  const sel = String(selected);
  if (stableColumnFilterValue(cellValue) === sel) return true;
  return String(cellValue) === sel;
}
